import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const DeletePermissionModal = ({ handleClose, show, modalInfo, onDelete }) => {
    const [userID, setUserID] = useState('');
    const [userName, setUserName] = useState('');
    const [selectfactory, setSelectFactory] = useState(0);
    const [selectCategory, setSelectCategory] = useState(0);
    const [selectRole, setSelectRole] = useState(0);
    const [createdBy, setCreatedBy] = useState('');

    useEffect(() => {
        setUserID(modalInfo.id);
        setUserName(modalInfo.name);
        setSelectFactory(modalInfo.factory);
        setSelectCategory(modalInfo.categoryID);
        setCreatedBy(localStorage.getItem('badgeID'));
    }, [modalInfo])

    const deleteFile = () => {
        onDelete({
            userID,
            userName,
            selectfactory,
            selectCategory,
            selectRole,
            createdBy
        });
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title
                    className='delete-modal-title'
                    style={{ color: '#c02d2e', marginBottom: '0px' }}
                >
                    Delete User's Role
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you wish to delete {userName}'s role?</Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={deleteFile}>
                    Delete Role
                </Button>
                <Button variant='outline-secondary' onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeletePermissionModal;
